"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: width,
    height: height,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter0_d_1054_496)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.8347 8.94488L13.8898 4L8.94488 8.94488L4 4V17.5276C4 18.1833 4.26049 18.8122 4.72416 19.2758C5.18783 19.7395 5.81671 20 6.47244 20H21.3071C21.9628 20 22.5917 19.7395 23.0554 19.2758C23.519 18.8122 23.7795 18.1833 23.7795 17.5276V4L18.8347 8.94488Z",
    fill: "#F86900"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "filter0_d_1054_496",
    x: "0",
    y: "0",
    width: "27.7793",
    height: "24",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", null), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.298039 0 0 0 0 0.0745098 0 0 0 1 0"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1054_496"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1054_496",
    result: "shape"
  }))));
};

exports["default"] = _default;